const locale = {
  common_ok: "确认",
  common_cancel: "取消",
  im_selected_invalid_date: "抱歉，您选择的日期无效，请重新选择",
  copy_success: "复制成功",
  please_select_time: "请选择时间",
  person_list: "人员列表",
};

export default locale;
